<template>
  <div id="declined-info-modal" class="uk-flex-top" uk-modal>
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto uk-margin-auto-vertical">
      <span class="uk-modal-title">{{$t('modals.declinedResource.whyWasTheResourceDeclined')}}</span>
      <div class="container">
        <p class="body-heading">{{$t('modals.declinedResource.reasons')}}</p>
        <div class="reason-container">
          <div class="reason-margin text" v-for="reason in reasons">
            <span>&#8226; {{reason}}</span>
          </div>
        </div>
      </div>
        <div v-if="declineInfo" class="info-container">
          <p class="body-heading">{{$t('modals.declinedResource.additionalInformation')}}</p>
          <span class="text">{{declineInfo}}</span>
        </div>
      <p class="uk-text-right button-container">
        <button class="modal-button uk-modal-close cp-primary-button add-pointer">
          {{$t('general.gotIt')}}
        </button>
      </p>
  </div>
  </div>
</template>

<script>
import {UNSUPPORTED_CONTENT, COPYRIGHT_INFRINGEMENT, PERSONAL_CONTENT, OTHER} from '../../../enums/resource-decline-reasons'

export default {
  name: 'declined-info',
  props: ['declineReasons', 'declineInfo'],
  computed: {
    reasons() {
      let reasons = []
      if (this.declineReasons) {
        this.declineReasons.forEach(reason => {
          switch (reason) {
            case UNSUPPORTED_CONTENT:
              reasons.push(this.$t('modals.declinedResource.unsupportedContent'))
              break
            case COPYRIGHT_INFRINGEMENT:
              reasons.push(this.$t('modals.declinedResource.copyrightInfringement'))
              break
            case PERSONAL_CONTENT:
              reasons.push(this.$t('modals.declinedResource.personalContent'))
              break
            case OTHER:
              reasons.push(this.$t('modals.declinedResource.other'))
          }
        })
      }
      return reasons
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/colours';
.body-heading {
  font-size: 18px;
  font-weight: bold;
  color: $content-text;
}

.button-container {
  margin-top: 56px;
}

.reason-container {
  margin-top: 25px
}

.reason-margin {
  margin-bottom: 10px;
}

.container {
  margin-top: 25px;
}

.info-container {
  margin-top: 30px;
}

text {
  font-size: 18px;
}

.modal-button {
  width: 240px;
  height: 44px;
  font-size: 18px;
  font-weight: bold;
}

.uk-modal-dialog {
  width: 676px;
  border-radius: 2.8px;
  box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
  background-color: $lightest-gray;
}

.uk-modal-title {
  font-size: 24px;
  font-weight: bold;
  margin-top: 32px;
  color: $content-text;
}
</style>
